// Redux
import api from '@/redux/redux-api';

// Types
import { AsyncResult, ApiAction } from '@/redux/index';
import { PortfolioShortMetrics } from '@/redux/modules/types/metrics';
import Portfolio from '@/types/portfolio';

export const queryPortfolioMetricsById =
  (endpointEntity: string, id: string, params?: Record<string, string>, body?: Portfolio): AsyncResult<PortfolioShortMetrics> =>
  () => {
    const action: ApiAction = {
      type: `connect/metrics/${endpointEntity}/`,
      endpoint: `${endpointEntity}/${id}/metrics`,
    };

    return api.post(action, params, body);
  };
